// A resource chosen in the picker is part of the save, even when the user
// hasn't pressed the separate Add requirement button.
export const withSelectedResource = (draft, type, identifier, name) => {
  const value = String(identifier || '').trim();
  if (!['qr', 'ble', 'audio'].includes(type) || !value) return draft;
  const anchors = draft.anchors || [];
  if (
    anchors.some(
      (anchor) => anchor.type === type && anchor.identifier === value
    )
  ) {
    return draft;
  }
  return {
    ...draft,
    anchors: [
      ...anchors,
      {
        id: `draft-${type}-${value}`,
        type,
        identifier: value,
        name,
        metadata: {},
      },
    ],
  };
};
